import LocalizedStrings from 'localized-strings';

export const periodLocales = new LocalizedStrings({
  en: {
    current_month: 'Current month',
    current_year: 'Current year',
    last_3_months: 'Last 3 months',
    last_month: 'Last month',
  },
  fr: {
    current_month: 'Mois en cours',
    current_year: 'Année en cours',
    last_3_months: '3 derniers mois',
    last_month: 'Mois dernier',
  },
});
